import { MutationTree } from 'vuex'

import { BrandSkuState } from '@/types/store'
import { IRecommend } from '@/types/recommend'

export const mutations: MutationTree<BrandSkuState> = {
  brandSkusLoadStart(state) {
    state.isBrandSkusLoading = true
  },
  brandSkusLoaded(state, brandSkus: IRecommend[]) {
    state.brandSkus = brandSkus
    state.isBrandSkusLoading = false
  },
}
